import { styled } from '@mui/material/styles';

export const HeaderContainer = styled('div')<{ reportOnly?: boolean }>(({ reportOnly }) => ({
  ...(reportOnly && {
    position: 'absolute',
    left: '-9999px',
    top: '0',    
    visibility: 'visible',
  }),
}));

export const MainHeader = styled('div')(() => ({
  marginTop: '20px',
  padding: '20px',  
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: '60px',
  gap: '20px',
  position: 'relative',
}));

export const RightSection = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flex: 1,
  gap: '8px',
}));

export const GeneratedText = styled('div')(({ theme }) => ({
  position: 'absolute',
  right: '20px',
  top: '50%',
  transform: 'translateY(-50%)',
  fontSize: '12px',
  color: theme.palette.text.secondary,
  fontFamily: theme.typography.fontFamily,
  textAlign: 'right',
  marginBottom: '8px',
}));

export const LogoImage = styled('img')(() => ({
  height: '42px',
  width: 'auto',
}));

export const BlueLine = styled('div')(({ theme }) => ({
  height: '2px',
  backgroundColor: theme.palette.primary.main,
  width: '100%',
  minWidth: '300px',
  marginTop: '20px',
}));

export const CompanyName = styled('div')(({ theme }) => ({
  fontSize: '22px',
  fontWeight: 'bold',
  color: theme.palette.text.primary,
  fontFamily: theme.typography.fontFamily,
  textAlign: 'center',
  lineHeight: 1.2,
  marginBottom: '4px',
}));
